<template>
  <v-container class="pa-0 fill-height" style="height: 90vh">
    <v-row class="flex-column fill-height">
      <v-col class="blue-background" style="overflow: auto; height: 80vh">
        <slot>
          <v-container>
            <p class="step-title">{{ $t('preAdmission.success.title') }}</p>
            <p>{{ $t('preAdmission.success.message') }}</p>
          </v-container>
        </slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'PreAdmissionSuccess'
};
</script>

<style scoped></style>
